import { TitlePage, ContainerPage } from "./styles"
import { useState, ChangeEvent } from "react"
import Replenishment from "./New"
import { Box, styled } from "@mui/material"

export const ComponentTitle = styled(Box)(({ color }: { color: string }) => ({
  width: "12px",
  height: "47px",
  borderRadius: "4px",
  backgroundColor: color,
}))

const ReplenishmentPage = () => {
  return (
    <ContainerPage style={{ height: "auto" }}>
      <TitlePage>
        <div style={{ display: "flex", alignItems: "center" }}>
          <ComponentTitle color={"#F8974C"} />
          <span
            style={{
              marginLeft: "28px",
              marginTop: "6px",
              width: "147px",
              height: "34px",
              font: "inter",
              fontWeight: "500",
              fontSize: "24px",
              lineHeight: "33.6px",
              letterSpacing: "1%",
              color: "#353535",
            }}
          >
            Abastecer
          </span>
        </div>
      </TitlePage>
      <Replenishment />
    </ContainerPage>
  )
}

export default ReplenishmentPage
